import { render, staticRenderFns } from "./RateCharges.vue?vue&type=template&id=5e631330&"
import script from "./RateCharges.vue?vue&type=script&lang=js&"
export * from "./RateCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports